import * as React from 'react'
function SvgTriangleDown(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20.002 31c.57 0 1.106-.278 1.433-.747l12.25-17.5A1.75 1.75 0 0032.252 10H7.748a1.75 1.75 0 00-1.433 2.753l12.25 17.5c.327.469.863.747 1.433.747h.004c-.002 0-.002 0 0 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgTriangleDown
